import React, { useState } from "react";
import { Card } from "@/components/ui/card";
import { OnboardingForm } from "@/components/auth/OnboardingForm";
import { ShieldCheck, ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminLogin() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4">
      {/* Background Decorative Element */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[10%] -right-[10%] w-[40%] h-[40%] bg-primary/10 blur-[120px] rounded-full" />
        <div className="absolute -bottom-[10%] -left-[10%] w-[40%] h-[40%] bg-primary/5 blur-[120px] rounded-full" />
      </div>

      <div className="w-full max-w-md relative z-10">
        <Link 
          to="/" 
          className="inline-flex items-center text-sm text-muted-foreground hover:text-white mb-8 transition-colors group"
        >
          <ChevronLeft className="w-4 h-4 mr-1 group-hover:-translate-x-1 transition-transform" />
          Voltar para o site
        </Link>

        <Card className="p-8 bg-[#111] border-[#222] shadow-2xl relative overflow-hidden">
          {/* Admin Tag */}
          <div className="absolute top-0 right-0 p-4">
            <div className="flex items-center gap-1.5 px-2 py-1 bg-primary/10 border border-primary/20 rounded text-[10px] uppercase font-bold text-primary tracking-wider">
              <ShieldCheck className="w-3 h-3" />
              Admin Portal
            </div>
          </div>

          <div className="mb-8">
            <h1 className="text-2xl font-heading font-bold text-white mb-2">Acesso Administrativo</h1>
            <p className="text-muted-foreground text-sm">
              Entre com suas credenciais para gerenciar a plataforma LEILIZE
            </p>
          </div>

          <OnboardingForm 
            initialMode="login" 
            redirectAfter="/admin" 
            hideToggle={true}
            hideSocial={true}
          />

          <div className="mt-8 pt-6 border-t border-[#222] text-center">
            <p className="text-[10px] text-muted-foreground uppercase tracking-[0.2em]">
              Sistema de Segurança de Alta Disponibilidade
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}
